(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/react/components/game-card/game-card.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/react/components/game-card/game-card.js');

'use strict';

const _React = React,
  useContext = _React.useContext,
  useLayoutEffect = _React.useLayoutEffect,
  useCallback = _React.useCallback,
  useRef = _React.useRef;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const _svs$ui$ReactAccordio = svs.ui.ReactAccordion,
  Accordion = _svs$ui$ReactAccordio.Accordion,
  AccordionItem = _svs$ui$ReactAccordio.AccordionItem,
  AccordionSummary = _svs$ui$ReactAccordio.AccordionSummary,
  AccordionDetails = _svs$ui$ReactAccordio.AccordionDetails;
const _svs$ui$ReactCard = svs.ui.ReactCard,
  Card = _svs$ui$ReactCard.Card,
  CardBody = _svs$ui$ReactCard.CardBody,
  CardHeader = _svs$ui$ReactCard.CardHeader,
  CardFooter = _svs$ui$ReactCard.CardFooter;
const Brand = svs.ui.ReactBrand;
const RibbonCorner = svs.ui.ReactRibbon.RibbonCorner;
const productMapping = svs.numbergames.productMapping;
const animations = svs.numbergames.fractiongames.components.gamecard.animations;
const ContainerContext = svs.numbergames.fractiongames.contexts.ContainerContext;
const _svs$numbergames$frac = svs.numbergames.fractiongames.constants.containerStates,
  CONTAINER_OPEN = _svs$numbergames$frac.CONTAINER_OPEN,
  GAME_SOLD_OUT = _svs$numbergames$frac.GAME_SOLD_OUT,
  CONTAINER_CLOSED = _svs$numbergames$frac.CONTAINER_CLOSED;
const _svs$numbergames$frac2 = svs.numbergames.fractiongames.components.gamecard,
  GameInfo = _svs$numbergames$frac2.GameInfo,
  ExtraGameInfo = _svs$numbergames$frac2.ExtraGameInfo,
  Header = _svs$numbergames$frac2.Header,
  Footer = _svs$numbergames$frac2.Footer,
  FooterClosed = _svs$numbergames$frac2.FooterClosed;
const GameCard = _ref => {
  let onPayEvent = _ref.onPayEvent;
  const _useContext = useContext(ContainerContext),
    selectors = _useContext.selectors,
    hasActiveCampaign = _useContext.hasActiveCampaign;
  const containerId = useSelector(selectors.selectContainerId);
  const activatedDrawId = useSelector(selectors.selectActivatedDrawId);
  const productNumeric = useSelector(selectors.selectProductNumeric);
  const sharePrice = useSelector(selectors.selectSharePrice);
  const containerState = useSelector(selectors.selectContainerState);
  const _useSelector = useSelector(selectors.selectGame),
    jokerPrice = _useSelector.jokerPrice,
    isSystemBoard = _useSelector.isSystemBoard;
  const branding = productMapping.getBrandingClass(productNumeric);
  const productName = productMapping.getProductName(productNumeric);
  const activatedDrawIdRef = useRef(activatedDrawId);
  const animationRef = useRef();
  const cardRef = useRef();
  const buttonRef = useRef();
  const closedFooterRef = useRef();
  const closedRef = useRef();
  useLayoutEffect(() => {
    if (activatedDrawIdRef.current !== activatedDrawId) {
      if (activatedDrawIdRef.current && activatedDrawId) {
        animations.gameRegeneratedAnimation(cardRef.current);
      }
      activatedDrawIdRef.current = activatedDrawId;
    }
  }, [activatedDrawId]);
  useLayoutEffect(() => {
    let tl;
    switch (containerState) {
      case CONTAINER_CLOSED:
      case GAME_SOLD_OUT:
        tl = animations.toExpiredAnimation(buttonRef.current, closedFooterRef.current, closedRef.current, {
          paused: true
        });
        break;
      case CONTAINER_OPEN:
        tl = animations.toOpenAnimation(closedFooterRef.current, buttonRef.current, closedRef.current, {
          paused: true
        });
        break;
      default:
    }
    if (tl) {
      var _animationRef$current, _animationRef$current2, _animationRef$current4;
      if ((_animationRef$current = animationRef.current) !== null && _animationRef$current !== void 0 && (_animationRef$current2 = _animationRef$current.isActive) !== null && _animationRef$current2 !== void 0 && _animationRef$current2.call(_animationRef$current)) {
        var _animationRef$current3;
        (_animationRef$current3 = animationRef.current) === null || _animationRef$current3 === void 0 || _animationRef$current3.progress(1);
      }
      if (!animationRef.current) {
        tl.progress(1);
      }
      animationRef.current = tl;
      (_animationRef$current4 = animationRef.current) === null || _animationRef$current4 === void 0 || _animationRef$current4.play();
    }
  }, [containerState]);
  const handlePayClick = useCallback(e => {
    e.preventDefault();
    onPayEvent(containerId);
  }, [onPayEvent, containerId]);
  const handleToggleExtraInfo = useCallback((e, isExpanded) => {
    if (isExpanded) {
      svs.components.analytics.trackEvent({
        category: 'Andelsspel',
        action: 'Mer info',
        opt_label: productName,
        opt_value: parseInt(sharePrice, 10)
      });
    }
  }, [productName, sharePrice]);
  return React.createElement("div", {
    className: "ng-fg-card ng-fg-card-container-".concat(containerId),
    ref: cardRef
  }, React.createElement(Card, {
    align: "center",
    branding: "tur",
    className: "branding-".concat(branding)
  }, React.createElement("div", {
    ref: closedRef
  }, React.createElement(CardHeader, null, hasActiveCampaign && React.createElement(RibbonCorner, null, "Kampanj"), React.createElement("div", {
    className: "ng-fg-card-header-brand"
  }, React.createElement("h2", null, React.createElement(Brand, {
    brand: branding,
    emblem: true,
    size: 100
  }), Boolean(jokerPrice) && React.createElement("p", null, "med Joker"))), React.createElement(Header, null)), React.createElement(CardBody, null, React.createElement(GameInfo, null), React.createElement(Accordion, {
    isFlat: true
  }, React.createElement(AccordionItem, {
    onChange: handleToggleExtraInfo
  }, React.createElement(AccordionSummary, null, isSystemBoard ? 'System' : 'Enkelrader'), React.createElement(AccordionDetails, null, React.createElement(ExtraGameInfo, null)))))), React.createElement(CardFooter, null, React.createElement(Footer, {
    onPay: handlePayClick,
    ref: buttonRef
  }), React.createElement(FooterClosed, {
    ref: closedFooterRef
  }))));
};
svs.numbergames.fractiongames.components.gamecard.GameCard = GameCard;

 })(window);